<template>
    <div class="container">
        <!-- 查询表单 -->
        <!-- <el-input size="mini" type="number" v-model="queryForm.user_id" placeholder="请输入用户ID"></el-input> -->
        <NumberInput v-model="queryForm.user_id" :placeholder="'请输入用户ID'" number-only :width="160" />
        <NumberInput v-model="queryForm.mobile_phone" :placeholder="'请输入用户手机号'" number-only :width="160" />
        <!-- <el-input size="mini" type="number" v-model="queryForm.mobile_phone" placeholder="请输入用户手机号"></el-input> -->
        <el-select v-model="queryForm.role_type" placeholder="请选择身份" size="mini">
            <el-option v-for="item in identityOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
        <NumberInput v-model="queryForm.remain_days_start" :placeholder="'请输入剩余天数'" number-only :width="160" />~
        <NumberInput v-model="queryForm.remain_days_end" :placeholder="'请输入剩余天数'" number-only :width="160" />
        <NumberInput v-model="queryForm.promoter_num_start" :placeholder="'请输入推广人数'" number-only :width="160" />~
        <NumberInput v-model="queryForm.promoter_num_end" :placeholder="'请输入推广人数'" number-only :width="160" />
        <!-- <el-input size="mini" type="number" v-model="queryForm.promoter_num_end" placeholder="请输入推广人数"></el-input> -->
        <NumberInput v-model="queryForm.total_amount_start" :placeholder="'请输入总分润金额'" number-only :width="160" />~
        <NumberInput v-model="queryForm.total_amount_end" :placeholder="'请输入总分润金额'" number-only :width="160" />
        <NumberInput v-model="queryForm.free_amount_start" :placeholder="'请输入可提现金额'" number-only :width="160" />~
        <NumberInput v-model="queryForm.free_amount_end" :placeholder="'请输入可提现金额'" number-only :width="160" />
        <el-select v-model="queryForm.examine_status" placeholder="选择审核状态" size="mini" clearable>
            <el-option v-for="item in examineStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
        <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
        <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
        <!-- 数据表格 -->
        <el-row>
            <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true" style="width: 100%; margin: 10px 0">
                <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
                <el-table-column prop="nickname" label="用户昵称" min-width="120"></el-table-column>
                <el-table-column prop="mobile_phone" label="手机号" width="130"></el-table-column>
                <el-table-column prop="role_type_text" label="身份" width="100"></el-table-column>
                <el-table-column prop="begin_at" label="开始时间" width="220"></el-table-column>
                <el-table-column prop="expire_at" label="到期时间" width="220"></el-table-column>
                <el-table-column prop="event_nickname" label="导购" width="220"></el-table-column>
                <el-table-column prop="join_num" label="签到次数" width="100"></el-table-column>
                <el-table-column prop="remain_days" label="剩余天数" width="100"></el-table-column>
                <el-table-column prop="total_income" label="总分润金额" width="120"></el-table-column>
                <el-table-column prop="free_income" label="可提现金额" width="120"></el-table-column>
                <el-table-column label="推广人数" width="100">
                    <template slot-scope="{row}">
                        <div style="color: #409eff; cursor: pointer;" @click="gopeopleList(row)">{{ row.promoter_num }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="{row}">
                        <el-button size="mini" type="text" @click="handleEdit(row)" v-if="row.status == 0">审核</el-button>
                        <el-button size="mini" type="text" @click="handleDelete(row)" v-if="row.status == 2">查看</el-button>
                        <el-button size="mini" type="text" @click="handleDeleteupdeta(row)" v-if="row.status ==2">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="queryForm.page" :page-size="queryForm.limit"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
        <el-dialog v-loading="showloading" title="用户身份认证信息" :visible.sync="showAuthDialog" width="50%" class="showAuthDialog">
            <el-form label-position="right" label-width="120px">
                <el-form-item label="您的姓名：">
                    <el-input v-model="authInfo.real_name" readonly></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="authInfo.mobile_phone" readonly></el-input>
                </el-form-item>
                <el-form-item label="身份证号码：">
                    <el-input v-model="authInfo.id_card" readonly></el-input>
                </el-form-item>
                <el-form-item label="银行卡号">
                    <el-input v-model="authInfo.bank_id_card" readonly></el-input>
                </el-form-item>
                <el-form-item label="开户行">
                    <el-input v-model="authInfo.bank_name" readonly></el-input>
                </el-form-item>
                <el-form-item label="身份证照片：">
                    <div class="id-card-images">
                        <el-image :src="authInfo.id_card_img1" :preview-src-list="[authInfo.id_card_img1]" style="width: 200px; margin-right: 20px;">
                        </el-image>
                        <el-image :src="authInfo.id_card_img2" :preview-src-list="[authInfo.id_card_img2]" style="width: 200px;">
                        </el-image>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="handleReject" v-if="unstatus == 0">拒 绝</el-button>
                <el-button type="primary" @click="handleApprove" v-if="unstatus == 0">同 意</el-button>
                <el-button type="info" @click="handlecancel" v-if="unstatus != 0">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog v-loading="showloading" title="用户身份认证信息" :visible.sync="showAuthDialog2" width="50%" class="showAuthDialog">
            <el-form label-position="right" label-width="120px" ref="infoForm">
                <el-form-item label="您的姓名：">
                    <el-input v-model="authInfo2.real_name"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="authInfo2.mobile_phone" @input="validateInput2" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码：">
                    <el-input v-model="authInfo2.id_card" maxlength="18"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号">
                    <el-input v-model="authInfo2.bank_id_card" maxlength="20" @input="validateInput3"></el-input>
                </el-form-item>
                <el-form-item label="开户行">
                    <el-input v-model="authInfo2.bank_name"></el-input>
                </el-form-item>
                <el-form-item label="身份证照片：">
                    <div class="id-card-images">
                        <activityCustomUpload :tip="''" :formName="'id_card_img1'" :formValue="authInfo2.id_card_img1" @uploadSuccess="uploadSuccess">
                        </activityCustomUpload>
                        <!-- <div>重新上传</div> -->
                        <activityCustomUpload :tip="''" :formName="'id_card_img2'" :formValue="authInfo2.id_card_img2" @uploadSuccess="uploadSuccess">
                        </activityCustomUpload>
                        <!-- <div>重新上传</div> -->
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <!-- <el-button type="danger" @click="handleReject" v-if="unstatus == 0">拒 绝</el-button> -->
                <el-button type="primary" @click="handleApprove2">确认</el-button>
                <el-button type="info" @click="showAuthDialog2 = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="请填写拒绝理由" :visible.sync="showReasonDialog" width="40%">
            <div class="reason-editor">
                <el-input type="textarea" :rows="5" v-model="rejectReason" placeholder="请输入拒绝理由（最多50字）" maxlength="50" show-word-limit></el-input>
            </div>
            <div slot="footer">
                <el-button @click="showReasonDialog = false">取 消</el-button>
                <el-button type="primary" @click="confirmReject">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    userlist,
    authentication,
    examine,
    infoUpdate,
} from "@/api/luminaryplan";
import activityCustomUpload from "@/components/activityCustomUpload.vue";
import NumberInput from "@/components/number_input.vue";
export default {
    data() {
        return {
            queryForm: {
                user_id: "",
                role_type: "",
                mobile_phone: "",
                remain_days_start: "",
                remain_days_end: "",
                promoter_num_start: "",
                promoter_num_end: "",
                total_amount_start: "",
                total_amount_end: "",
                free_amount_start: "",
                free_amount_end: "",
                examine_status: "",

                page: 1,
                limit: 10,
            },
            registerDate: [],
            identityOptions: [
                { value: "", label: "全部" },
                { value: "city", label: "市代" },
                { value: "courier", label: "驿站" },
                { value: "notAgent", label: "非代理" },
            ],
            examineStatus: [
                { value: -1, label: "未提交" },
                { value: 0, label: "待审核" },
                { value: 2, label: "已审核" },
            ],
            tableData: [
                // 示例数据
                {
                    id: 1001,
                    nickname: "测试用户",
                    mobile: "13800138000",
                    identity: "代理商",
                    startDate: "2023-01-01",
                    endDate: "2024-01-01",
                    remainingDays: 200,
                    totalAmount: "5000.00",
                    withdrawable: "3000.00",
                    promotionCount: 50,
                },
                {
                    id: 1002,
                    nickname: "测试用户",
                    mobile: "13800138000",
                    identity: "代理商",
                    startDate: "2023-01-01",
                    endDate: "2024-01-01",
                    remainingDays: 200,
                    totalAmount: "5000.00",
                    withdrawable: "3000.00",
                    promotionCount: 50,
                },
            ],
            multipleSelection: [],
            showAuthDialog: false,
            showAuthDialog2: false,
            authInfo: {
                real_name: "",
                mobile_phone: "",
                id_card: "",
                id_card_img1: "",
                id_card_img2: "",
                bank_name: "",
                bank_id_card: "",
            },
            authInfo2: {
                real_name: "",
                mobile_phone: "",
                id_card: "",
                id_card_img1: "",
                id_card_img2: "",
                bank_name: "",
                bank_id_card: "",
            },
            showReasonDialog: false,
            rejectReason: "",
            remainingChars: 50,
            total: 0,
            user_id: 0,
            unstatus: "",
            loading: false,
            showloading: false,
        };
    },
    mounted() {
        this.getList();
    },
    components: {
        NumberInput, // 导入自定义组件
        activityCustomUpload,
    },
    methods: {
        handleApprove2() {
            infoUpdate(this.authInfo2).then((res) => {
                if (res.status === "2000") {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    this.showAuthDialog2 = false;
                    this.getList();
                }
            });
        },
        validateInput(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.authInfo2.id_card = value;
        },
        validateInput2(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.authInfo2.mobile_phone = value;
        },
        validateInput3(event) {
            console.log(event);

            let value = event;
            // 移除非数字字符
            value = value.replace(/\D/g, "");
            // 检查第一个字符是否为0
            if (value.length > 0 && value[0] === "0") {
                value = value.substring(1);
            }
            this.authInfo2.bank_id_card = value;
        },
        uploadSuccess(value) {
            const fileExtension = value.fileUrl.split(".").pop().toLowerCase();
            console.log(value, "value");

            // 判断是否是图片格式
            const isImageFormat = ["png", "jpeg", "jpg", "gif", ""].includes(
                fileExtension
            );

            if (isImageFormat) {
                // console.log('是图片格式');
                this.authInfo2[value.formName] = value.fileUrl;
                console.log(
                    this.authInfo2[value.formName],
                    "this.authInfo2[value.formName]"
                );

                this.$refs.infoForm.validateField(value.formName);
            } else {
                this.$message({
                    message: "请上传图片格式文件",
                    type: "error",
                });
                return;
            }
        },
        handleSearch() {
            console.log("搜索参数：", this.queryForm);
            // 这里添加搜索逻辑
            this.queryForm.page = 1;
            this.getList();
        },
        handleExport() {
            const params = new URLSearchParams();
            const fullUrl = window.location.origin;
            console.log(fullUrl);

            // 遍历 queryForm，只添加有值的参数
            Object.entries(this.queryForm).forEach(([key, value]) => {
                if (value !== null && value !== undefined) {
                    params.append(key, value);
                }
            });
            // http://admin.defen.hzxinquanzi.com/?c=performance&m=performance_list&p=150
            //https://dev.backend.zhangdefenspace.com/ https://backend.zhangdefenspace.com/
            const url = `${fullUrl}/backend/activity/luminary/user/list/export?${params.toString()}`;
            location.href = url;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log("多选选择：", val);
        },
        // shenhe
        handleEdit(row) {
            this.authenticationHandel(row.user_id);
            this.unstatus = row.status;
            this.user_id = row.user_id;
            this.showAuthDialog = true; // 打开弹窗
        },
        // chakan
        handleDelete(row) {
            this.authenticationHandel(row.user_id);
            this.unstatus = row.status;
            this.user_id = row.user_id;
            this.showAuthDialog = true; // 打开弹窗
        },
        handleDeleteupdeta(row) {
            this.authenticationHandel(row.user_id);
            this.unstatus = row.status;
            this.user_id = row.user_id;
            // this.authInfo2 = row;
            this.showAuthDialog2 = true;
        },
        handleReject() {
            console.log("拒绝");
            // this.showAuthDialog = false; // 关闭第一个弹窗
            this.showReasonDialog = true; // 打开拒绝理由弹窗
            this.rejectReason = ""; // 重置理由
            this.remainingChars = 50; // 重置字数
        },
        handleApprove() {
            this.$confirm("是否确认审核通过？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    examine({ user_id: this.user_id, status: 2 }).then(
                        (res) => {
                            if (res.code == 1) {
                                this.$message.success("操作成功");
                                this.showReasonDialog = false;
                                this.getList();
                            }
                        }
                    );
                    this.showAuthDialog = false;
                })
                .catch(() => {});
        },
        handlecancel() {
            this.showAuthDialog = false;
        },
        confirmReject() {
            if (this.rejectReason.trim().length === 0) {
                this.$message.warning("请填写拒绝理由");
                return;
            }
            examine({
                user_id: this.user_id,
                status: 1,
                reason: this.rejectReason,
            }).then((res) => {
                if (res.code == 1) {
                    this.$message.success("操作成功");
                    this.showReasonDialog = false;
                    this.getList();
                    this.showAuthDialog = false;
                }
            });
            this.showReasonDialog = false;
            // 这里添加实际拒绝逻辑
        },
        gopeopleList(row) {
            console.log(row);
            this.$router.push({
                path: "/luminaryplan/people_list",
                query: {
                    id: row.user_id,
                },
            });
        },
        getList() {
            console.log("获取列表数据");
            this.loading = true;
            userlist(this.queryForm).then((res) => {
                if (res.code == 1) {
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                    this.loading = false;
                    // this.user_id = res.data.list.user_id
                }
            });
        },
        authenticationHandel(id) {
            this.showloading = true;
            authentication({ user_id: id }).then((res) => {
                if (res.code == 1) {
                    this.authInfo = res.data;
                    this.authInfo2 = res.data;
                    this.showloading = false;
                    // this.showAuthDialog = true
                }
            });
        },
    },
};
</script>

<style scoped>
.container {
    padding: 20px 10px;
}
.container .el-input {
    width: 160px;
    margin: 0 10px 10px;
}
.container .showAuthDialog .el-input {
    width: 300px;
}
.container .showAuthDialog .el-form-item {
    margin-bottom: 0px;
}
.el-table {
    margin-top: 10px;
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}
</style>
